import React from 'react';
export var ODEntityContext = React.createContext(undefined);
export var ODEntityProvider = ODEntityContext.Provider;
export var ODEntityConsumer = ODEntityContext.Consumer;
/**
 * useODEntityContext 는 직접적으로 entity context 에 접근해야 하는 경우에 사용합니다. 대부분의 경우에는
 * 컴포넌트들을 이용하여 사용하게 됩니다.
 */
export function useODEntityContext() {
    var odEntityContext = React.useContext(ODEntityContext);
    if (!odEntityContext) {
        // tslint:disable-next-line:no-console
        console.warn("ODEntityContext is undefined, please verify you are calling useODEntityContext() as child of a <ODEntity> component.");
    }
    return odEntityContext;
}
//# sourceMappingURL=useODEntityContext.js.map